export default __webpack_public_path__ + "static/media/25.151ed5de.png";